import API_CONFIG from "./index";

const { FULL_BASE_URL } = API_CONFIG;

export const ENDPOINTS = {
  AUTH: {
    LOGIN: `${FULL_BASE_URL}/auth/login`,
  },

  GET_DATA: {
    TO_DAV_MOBILE: (document: string) => `${FULL_BASE_URL}/get-data/to-dav-mobile/${document}`,
    TO_EXPRESSO: (document: string) => `${FULL_BASE_URL}/get-data/to-expresso/${document}`,
  },

  RECEIVES_DATA: {
    FROM_DAV_MOBILE: (document: string) =>
      `${FULL_BASE_URL}/receives-data/from-dav-mobile/${document}`,
    FROM_EXPRESSO: (document: string) => `${FULL_BASE_URL}/receives-data/from-expresso/${document}`,
  },

  HEALTH_CHECK: `${FULL_BASE_URL}/health-check`,
} as const;

export default ENDPOINTS;
